"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandleInteractionChangedAndValidateRegistrationNumberCommand = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var HandleInteractionChangedAndValidateRegistrationNumberCommand = /** @class */ (function (_super) {
    __extends(HandleInteractionChangedAndValidateRegistrationNumberCommand, _super);
    function HandleInteractionChangedAndValidateRegistrationNumberCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HandleInteractionChangedAndValidateRegistrationNumberCommand.prototype.exec = function (props) {
        var questionName = this.getSetting("questionName", props.journeyEventDefinition.settings);
        return this.journeyRuntimeService.doBackendAction("registrationNumberValidate", props.interaction, {}, this.isAuthRequired(props)).toPromise().catch(function (error) {
            return Promise.reject({
                error: error
            });
        }).then(function (interaction) {
            props.updateInteraction(interaction);
            if (questionName) {
                props.engine.validateQuestion(questionName);
            }
            return {};
        });
    };
    HandleInteractionChangedAndValidateRegistrationNumberCommand = __decorate([
        (0, journey_model_1.settings)([
            { name: "questionName", type: journey_model_1.TypeDescriptions.String }
        ])
    ], HandleInteractionChangedAndValidateRegistrationNumberCommand);
    return HandleInteractionChangedAndValidateRegistrationNumberCommand;
}(plugin_journey_1.BackendCommand));
exports.HandleInteractionChangedAndValidateRegistrationNumberCommand = HandleInteractionChangedAndValidateRegistrationNumberCommand;
//# sourceMappingURL=HandleInteractionChangedAndValidateRegistrationNumberCommand.js.map